import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

/**
 * AlternatePickSlot - Displays a slot for alternate fighter selections
 * 
 * @param {Object} props
 * @param {Object} props.fighter - The selected fighter object
 * @param {function} props.onRemove - Callback to remove the alternate fighter
 * @param {Object} [props.opponent] - Optional opponent data (if not provided, will show generic opponent)
 */
const AlternatePickSlot = ({ fighter, onRemove, opponent = null }) => {
  // Function to format opponent name (first initial + last name)
  const formatOpponentName = (opp) => {
    if (!opp) return "Opponent";
    return `${opp.FirstName.charAt(0)}. ${opp.LastName}`;
  };

  return fighter ? (
    <div className="border border-gray-300 rounded-lg bg-white shadow-sm overflow-hidden hover:shadow-md transition-all duration-200">
      <div className="p-2">
        <div className="flex items-center gap-2">
          {/* Fighter info - takes up available space */}
          <div className="flex-1 min-w-0">
            <div className="font-bold text-sm text-dark-grey leading-tight truncate">
              {fighter.FirstName} {fighter.LastName}
            </div>
            <div className="flex items-center text-xs text-medium-grey">
              <span>vs {formatOpponentName(opponent)}</span>
              <span className="mx-1">•</span>
              <span className="text-[10px] uppercase tracking-wide bg-gray-100 px-1 py-0.5 rounded">
                {fighter.WeightClass}
              </span>
            </div>
          </div>
          
          {/* Remove button */}
          <div className="flex items-center">
            <button
              onClick={() => onRemove(fighter.FighterId)}
              className="w-8 h-8 flex items-center justify-center bg-light-grey text-dark-grey hover:bg-red-100 hover:text-red-600 hover:scale-110 active:scale-95 rounded text-xs transition-all duration-150 flex-shrink-0"
              aria-label="Remove alternate"
              title="Remove alternate"
            >
              <FontAwesomeIcon icon={faXmark} size="xs" />
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default AlternatePickSlot; 